










import {Vue, Component, Prop} from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
    computed:mapGetters({
      socketConnected: 'socket/isConnected',
    }),
})
export default class DateAndTime extends Vue{
    currentTime:string = "";
    currentDate:string = "";
    intervalId:any;

    updateTime(){
        var today = new Date();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();
        var month = today.getMonth()+1;
        var day = today.getDate();
        m = this.checkTime(m);

        this.currentTime = h + ":" + m; 
        this.currentDate = today.getUTCFullYear().toString() + "-" + this.checkTime(month) + "-" + this.checkTime(day);
    }

    checkTime(i:any) {
        if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
        return i;
    }

    mounted(){
        this.updateTime();
        this.intervalId = setInterval(() => this.updateTime(), 60000);
        // this.intervalId = setInterval(() => this.updateTime(), 300);
    }

    destroyed(){

        clearInterval(this.intervalId);

    }
    
}
